import { useIntl } from 'react-intl'
import Modal from 'LuxKit/Modal/Modal'
import CashRefundCancellationPolicyTimelineContent from './CashRefundCancellationPolicyTimelineContent'
import type { CashRefundCancellationTimelineDetails } from './cashRefundCancellationPolicyTimelineUtils'

interface Props {
  details: CashRefundCancellationTimelineDetails
}

function CashRefundCancellationPolicyModal(props: Props) {
  const { details } = props
  const intl = useIntl()

  return (
    <Modal
      title={intl.formatMessage({
        id: 'ip9FOw9dQ_KIKaoEbQDw',
        defaultMessage: 'Cancellation policy',
        description: 'Title for flexible cancellation policy modal in the cancellation flow',
      })}
    >
      <CashRefundCancellationPolicyTimelineContent details={details} />
    </Modal>
  )
}

export default CashRefundCancellationPolicyModal
